<template>
  <router-view />
</template>

<script lang="ts" setup>
//
</script>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  height: 100%;
}
</style>
